import { h } from 'preact'
import { useMemo } from 'preact/hooks'

import { Meta, MetaDate, MetaLink } from '../../atom/Meta'
import InlineTitle from '../../atom/InlineTitle'
import { TITLES } from '../../../config'
import TagList from '../TagList'
import PageList from '../PageList'
import Expandable from '../Expandable'
import { HorizontalMenu, HorizontalMenuEntry } from '../../atom/HorizontalMenu'

import { buildClassNames } from './classNames'

const MAX_VISIBLE_TAGS = 18

export const ArticleContentFooter = (props) => {
  const {
    className,
    meta = {},
    author = {},
    categories,
    tags = [],
    pages = [],
  } = props

  const sortedCategories = useMemo(
    () => Array.from(categories || [])
      .sort((a, b) => a.slug.localeCompare(b.slug)),
    [categories],
  )

  const pageLinks = useMemo(
    () => {
      if (pages.length <= 1) {
        return []
      }

      return pages.map(page => ({
        id: page.permalink,
        permalink: page.current ? null : page.href,
        label: page.page,
      }))
    },
    [pages],
  )

  return (
    <footer className={buildClassNames({
      className,
      narrow: true,
      marginTop: true,
    })}>
      <Meta borderTop marginBottom small>
        <HorizontalMenu balanced>
          <HorizontalMenuEntry>
            {author.url ? <MetaLink href={author.url}>{author.name}</MetaLink> : author.name}
            {pages.length ? <br /> : ' | '}
            <MetaDate className="published" date={meta.publishedDate} />
          </HorizontalMenuEntry>

          {pages.length ? (
            <HorizontalMenuEntry>
              <InlineTitle>{TITLES.PAGES}</InlineTitle>
              <PageList
                inline
                entries={pageLinks}
                linkProps={{ internal: true }}
              />
            </HorizontalMenuEntry>
          ) : null}
        </HorizontalMenu>
      </Meta>

      {sortedCategories.length ? (
        <Meta
          small
          borderBottom={!tags.length}
          marginBottom={tags.length}
        >
          <InlineTitle>{TITLES.CATEGORIES}</InlineTitle>
          {/* TODO: use a category specific style for the list */}
          <PageList entries={sortedCategories} linkProps={{ rel: 'category' }} />
        </Meta>
      ) : null}

      {tags.length ? (
        <Meta
          small
          borderBottom
        >
          <InlineTitle>{TITLES.TAGS}</InlineTitle>
          {tags.length > MAX_VISIBLE_TAGS ? (
            <Expandable height="8em">
              <TagList entries={tags} linkProps={{ rel: 'tag' }} />
            </Expandable>
          ) : (
            <TagList entries={tags} linkProps={{ rel: 'tag' }} />
          )}
        </Meta>
      ) : null}
    </footer>
  )
}
